<template>
  <div></div>
</template>

<script>
import * as yhxx from "@/api/yhxx";
import * as login from "@/api/login";

export default {
  name: "casLogin",
  components: {},
  computed: {},
  data() {
    return {};
  },
  methods: {},
  created() {
    let _this = this;
    let cas = _this.$route.query.cas;
    login.casLoginToken(cas).then((res) => {
      if (res.data.code.toString() == "200") {
        login.getPubKey().then((res1) => {
          let sessionId = res1.data.data.sessionId;
          let publicKey = res1.data.data.publicKey;
          //创建jsencrypt加密对象
          const jsRsa = new _this.$jsEncrypt();
          //设置公钥
          jsRsa.setPublicKey(publicKey);

          //使用加密对象给密码加密也可以对用户名等加密
          let playload = jsRsa.encrypt(cas);
          let params = {
            username: res.data.data,
            password: playload,
            sessionId: sessionId,
          };
          login.login(_this.$qs.stringify(params)).then(async function(res2) {
            if (res2.data.code == "200") {
              // 获取系统参数信息
              yhxx.selectShowAllCs().then((tmpResult) => {
                let tmpObj = {};
                for (let tmp of tmpResult.data.data) {
                  if (tmp.csid === "isCollapse") {
                    _this.$store.commit(
                      "setIsCollapse",
                      tmp.csvalue === "1" ? true : false
                    );
                  }
                  tmpObj[tmp.csid] = tmp.csvalue;
                }
                _this.$store.dispatch("setSysCs", tmpObj);
              });
              _this.$store.commit("setCasLogin", true);
              _this.$store.commit("setSessionId", sessionId);
              _this.$store.commit("setPubKey", publicKey);
              let userInfo = res2.data.data;
              // 将用户token保存到vuex中
              _this.$store.commit("setUserRole", userInfo.suid);
              _this.$store.commit("setUserName", userInfo.uname);
              _this.$store.commit("setUserId", userInfo.suid);
              _this.$store.commit("setToken", userInfo.token);
              _this.$session.setItem("gzfpObject", JSON.stringify(userInfo));
              // 获取登陆用户信息
              _this.$requestUtil
                .getUserInfo({ suid: userInfo.suid })
                .then((tmpResult) => {
                  _this.$store.commit("setUserInfo", tmpResult);
                });
              // 获取用户习惯信息
              let tmpLimit = 10;
              let tmpPageSizes = _this.$comUtils.formatPageSizes(tmpLimit);
              _this.$store.commit("setPageLayout", "1");
              _this.$store.commit("setDataDisplayNum", tmpLimit);
              _this.$store.commit("setPageSizes", tmpPageSizes);
              _this.$store.commit("setNoticeDisplay", "1");
              // 获取系统公告
              _this.$requestUtil
                .getNoticeList({ currentPage: 0, fbzt: "1" })
                .then((tmpResult) => {
                  _this.$store.dispatch("setSysNotice", tmpResult);
                });
              // 获取用户信息
              yhxx.getYhxx().then((res3) => {
                _this.$store.commit("yhxx/setYhxx", res3.data.data);
              });
              _this.$router.push({ path: "/" });
            } else {
              _this.$router.push({ path: "/login" });
            }
          });
        });
      }
    });
  },
  mounted() {},
  destroyed() {},
};
</script>
